import {
  getCaretPosition,
  restoreCaretPosition,
  waitForElement,
} from "../../dom";

export const updateTitleWrapper = (wrapper, editorDocument, id, actions) => {
  // Get current selection
  var selection = editorDocument.getSelection();

  // Get current Richtext Input from selection
  var currentEditableRichText =
    selection?.anchorNode?.parentElement?.closest(
      ".grigora-richtext-input__field[contenteditable='true']",
    ) ||
    selection?.anchorNode?.closest?.(
      ".grigora-richtext-input__field[contenteditable='true']",
    );

  // Get all richtexts in the block
  var richtexts = editorDocument.querySelectorAll(
    `[data-grigora-block-id="${id}"] .grigora-richtext-input__field`,
  );

  // Get current richtext index
  var richtextIndex = Array.from(richtexts).indexOf(currentEditableRichText);

  // Save caret Position
  var caretPos = getCaretPosition(editorDocument, currentEditableRichText);

  actions.setProp(id, (props) => {
    props.titleWrapper = wrapper;
  });

  waitForElement(
    editorDocument,
    ".faq-" + id + ` ${wrapper}.grigora-richtext-input__field`,
  ).then((elm) => {
    // Get all richtexts in the block
    var richtexts = editorDocument.querySelectorAll(
      `[data-grigora-block-id="${id}"] .grigora-richtext-input__field`,
    );

    var elm = richtexts[richtextIndex];

    restoreCaretPosition(editorDocument, elm, caretPos);
  });
};
